import { Component, OnInit } from '@angular/core';
import { GetExcelService } from 'src/app/providers/excel/get-excel.service';
import { PoliciesService } from 'src/app/providers/policy/policies.service';
import { NotificationService } from 'src/app/service/toaster/notification.service';
import Swal from 'sweetalert2';
declare let $: any;
@Component({
  selector: 'app-download-qr-code',
  templateUrl: './download-qr-code.component.html',
  styleUrls: ['./download-qr-code.component.scss']
})
export class DownloadQrCodeComponent implements OnInit {
  qrimage: any;
  myPermissions: any = [];
  printContents: any;
  bodyContents: any;
  empDtata: any = {};
  constructor(private httpPolicy: PoliciesService,
              private notifyService: NotificationService,
              public httpBasePath: GetExcelService) { }

  ngOnInit(): void {
    this.getMyPermissions();
  }

  getMyPermissions(): void {
    this.httpPolicy.myWorkPermissions().subscribe(res => {
      if (res.status) {
        this.myPermissions = res.data;
      } else {
        // this.notifyService.showInfo(res.msg, 'Info!');
      }
    });
  }
  checkOut(data): void {
    Swal.fire({
      title: 'Are you sure ?',
      text: 'You want to checkout!',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes!',
      cancelButtonText: 'No, keep it'
    }).then((result) => {
      if (result.isConfirmed) {
        this.httpPolicy.checkOut({booking_id: data.booking_id}).subscribe(res => {
          if (res.status) {
            this.getMyPermissions();
            this.notifyService.showSuccess(res.msg, 'Success!');
          } else {
            this.notifyService.showInfo(res.msg, 'Info!');
          }
        });
      }
    });
  }
  cancelReq(data): void {
    Swal.fire({
      title: 'Are you sure ?',
      text: 'You want to withdraw this booking request!',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes!',
      cancelButtonText: 'No, keep it'
    }).then((result) => {
      if (result.isConfirmed) {
        this.httpPolicy.wpReqCancel({booking_id: data.booking_id}).subscribe(res => {
          if (res.status) {
            this.getMyPermissions();
            this.notifyService.showSuccess(res.msg, 'Success!');
          } else {
            this.notifyService.showInfo(res.msg, 'Info!');
          }
        });
      }
    });
  }

  qrCodeModal(id, data): void {
    this.empDtata = data;
    this.qrimage = data.qr_code_attach;
    $(id).modal({keyboard: false });
  }

  closeModal(id): void {
    $(id).modal('hide');
  }

  printBarcode(): void {
    this.bodyContents = document.body.innerHTML;
    this.printContents = document.getElementById('myPrint').innerHTML;
    document.body.innerHTML = '<html<head><title></title></head><body>' + this.printContents + '</body></html>';

    window.print();

    document.location.reload();
  }
}
